export default 'notifications'
